// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { getToken } from "../../../components/src/AuthService";
import React from "react";
import {
  titleImg1,
  titleImg2,
  titleImg3,
  payment_3,
  PaymentStripe,
  titleImg4,
  groupStarbar2,
  groupStarbar,
  groupStarbar3,
  groupStarbar4,
} from "./assets";

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
}

interface S {
  emailAddress: string;
  emailError: string;
  formError: any;
  currentStep: number;
  hasLowerCaseLetter: boolean;
  hasNumber: boolean;
  hasMinLength: boolean;
  sideBarContent: {
    [step: number]: {
      imagetitle: string;
      image: string;
    };
  };
  businessWebsite: string;
  zipcode: any;
  mobileNumber: any;
  otp: string[];
  emailValidationResult: any;
  paymentError?: string;
  EmailPasswordID: number;
  userToken: string;
  selectedPricing: PlanPricing;
  showSuccessMessage: boolean;
  paymentPlanData: ProductData[];
  platformManagementPaymentPlans: ProductData[];
  stripePaymentData: any;
  clientSecretKey: string;
  formGlobalError: any;
  showPassword: boolean;
  businessPassword: string;
  businessConfirmPassword: string;
  showConfirmPassword: boolean;
  passwordsMatch: boolean;
  hasCapitalLetter: boolean;
  passWordInformation: string;
  attributeName: string;
  paymentPrize: number;
  activeBoxIndex: number;
  isSelectedPlanWithPlatformManagement: boolean;
  selectedPlanData: any;
}

export interface Plan {
  id: any;
  price: any | undefined;
  created_at: string;
  updated_at: string;
  product_id: number;
  currency: string | undefined;
  interval: string | undefined;
  stripe_plan_id: string;
  stripe_prod_id: string;
}

export interface ProductData {
  id: string;
  type: string;
  attributes: ProductAttributes;
}

interface SS {
  id: any;
}

export interface ProductAttributes {
  id: any;
  name: string;
  description: string;
  stripe_prod_id: string;
  plans: Plan[];
  service?: Service | null;
  platformManagement?: boolean;
}

export interface PaymentPlan {
  id?: number;
  type: string;
  name: string;
  description: string;
  plans: Plan[];
  data: ProductData[];
  bestFor: string;
  pricePerMonth: number;
  discountPricePerMonth: number;
  advantages: string[];
  attributes: ProductAttributes;
}
export interface PaymentPlanData {
  data: ProductData[];
}

interface Service {
  id: any;
  product_id: number;
  max_members_count: string;
  permissions: any;
  created_at: string;
  updated_at: string;
  max_contacts_count: string;
}

export enum PlanPricing {
  Annual = "year",
  Month = "month",
}

export enum PlanType {
  Essentials = "Essentials",
  Standard = "Standard",
  Proffecional = "Proffecional",
}
export default class EmailAccountRegistrationController extends BlockComponent<
  Props,
  S,
  SS
> {
  apiStripeProductDetailsId: any = "";
  apiUserRegistrationId: any = "";
  createIntentId:any = "";
  apiSubcriptionSelectionId: any = "";
  apiStripeSubscriptionCancelId: any = "";

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      getName(MessageEnum.CountryCodeMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.ReciveUserCredentials),
    ];

    this.state = {
      emailAddress: "",
      showPassword: false,
      showConfirmPassword: false,
      passwordsMatch: true,
      sideBarContent: {
        1: {
          imagetitle: titleImg1,
          image: groupStarbar,
        },
        2: {
          imagetitle: titleImg2,
          image: groupStarbar2,
        },
        3: {
          imagetitle: titleImg3,
          image: groupStarbar3,
        },
        4: {
          imagetitle: titleImg4,
          image: groupStarbar4,
        },
        6: {
          imagetitle: payment_3,
          image: PaymentStripe,
        },
      },
      zipcode: "",
      mobileNumber: "",
      hasCapitalLetter: false,
      hasLowerCaseLetter: false,
      hasNumber: false,
      hasMinLength: false,
      currentStep: 1,
      formError: {},
      formGlobalError: {},
      passWordInformation: "",
      emailError: "",
      businessPassword: "",
      businessConfirmPassword: "",
      attributeName: "",
      paymentPrize: 0,
      paymentError: undefined,
      activeBoxIndex: 1,
      selectedPricing: PlanPricing.Annual,
      businessWebsite: "",
      showSuccessMessage: false,
      paymentPlanData: [],
      platformManagementPaymentPlans: [],
      otp: Array(6).fill(""),
      emailValidationResult: "q@q.com",
      EmailPasswordID: 0,
      userToken: "",
      stripePaymentData: "",
      clientSecretKey:"",
      isSelectedPlanWithPlatformManagement: false,
      selectedPlanData:[]
    };

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    this.clearSession();
  }

  componentDidMount(): any {
    if (window.location.pathname === "/subscription") {
      this.setState(
        {
          currentStep: 5,
          userToken: getToken(),
        },
        () => this.stripeProductDetailsAPI()
      );
    }
  }

  clearSession() {
    sessionStorage.clear();
  }

  setSelectedPricing = (pricing: PlanPricing) => {
    this.setState({ selectedPricing: pricing });
  };
  setActiveBoxIndex = (index: number) => {
    this.setState({ activeBoxIndex: index });
  };

  getPriceValue = (paymentPlan: any) => {
    const planPrice = paymentPlan.attributes?.plans?.find(
      (item: any) => item.interval === this.state.selectedPricing
    );
    if (planPrice) {
      return {
        productId: paymentPlan.id,
        price: planPrice.price,
        currency: planPrice.currency,
        interval: planPrice.interval,
        stripe_price_id: planPrice.stripe_plan_id,
        plan_id: planPrice.id,
        name: paymentPlan.attributes.name,
        subscription_id: paymentPlan.attributes.id,
      };
    } else {
      return {
        productId: "",
        price: "",
        currency: "",
        interval: "",
        stripe_price_id: "No Data Available",
        plan_id: "No Data Available",
        name: "No Data Available",
        subscription_id: ""
      };
    }
  };

  handleGoBackClick = () => {
    sessionStorage.setItem("valuesBackStep", "true");
    this.setState((prevState) => ({
      currentStep: prevState.currentStep - 1,
    }));
  };

  handleGoToPlanSelection = () => {
    this.setState((prevState) => ({
      currentStep: prevState.currentStep - 1,
    }));

    this.doSubcriptionCancel();
  };

  setPlatformManagement = (planId?: string) => {    
    this.setState({
      paymentPlanData: this.state.paymentPlanData.map((plan) => {
        if (plan.id === planId) {
          plan.attributes.platformManagement = !plan.attributes
            .platformManagement;
        } else {
          plan.attributes.platformManagement = false;
        }

        return plan;
      }),
    });
  };

  setSelectedPlan = (plan: ProductData) => {
    const apiData = plan && this.getPriceValue(plan);
    this.setState({ 
      attributeName: apiData.name, 
      paymentPrize: apiData?.price,
      selectedPlanData: apiData
    });    
    // Call doSubcriptionSelection to create subscription and get client_secret
    this.doSubcriptionSelection(apiData);
  };


  async doSubcriptionSelection(planData: any) {
    if (
      !planData ||
      !planData.stripe_price_id ||
      !planData.plan_id
    ) {
      console.warn("❌ No valid plan data for subscription selection.");
      return false;
    }

    const attrs = {
      stripe_price_id: planData.stripe_price_id,
      plan_id: planData.plan_id,
      platform_management: this.state.isSelectedPlanWithPlatformManagement,
      subscription_id: planData.subscription_id || planData.productId,
    };

    const httpBody = {
      subscription: attrs,
    };

    const headerData = {
      "Content-Type": configJSON.signupEmailApiContentType,
      Token: this.state.userToken,
    };

    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.apiSubcriptionSelectionId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.signupAPiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.StripesubScriptionsDetails
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }

     updateBuPlan(selectedPlan: any) {

      console.log("selectedPlan", selectedPlan);
      this.setState({
          selectedPlanData: selectedPlan
        })
      
        const headerData = {
          Token: this.state.userToken
        };
        console.log("headerDataheaderData token show", headerData);
        
        let requestMessage = new Message(
          getName(MessageEnum.RestAPIRequestMessage)
        );
  
        this.createIntentId = requestMessage.messageId;
        requestMessage.addData(
          getName(MessageEnum.RestAPIRequestHeaderMessage),
          JSON.stringify(headerData)
        );
        requestMessage.addData(
          getName(MessageEnum.RestAPIResponceEndPointMessage),
          configJSON.createIntentEndPoint
        );
        requestMessage.addData(
          getName(MessageEnum.RestAPIRequestMethodMessage),
          configJSON.signupAPiMethod
        );
        runEngine.sendMessage(requestMessage.id, requestMessage);
  
    }

  // subscriptions data Call
  stripeProductDetailsAPI() {
    console.log("show detail on payment data data data");
    
    const headerData = {
      "Content-Type": configJSON.signupEmailApiContentType,
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.apiStripeProductDetailsId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.StripeProductDetails
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.StripeProductDetailsAPiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }

  async doSubcriptionCancel() {
    const httpBody = {
      stripe_subscription_id: this.state.stripePaymentData.id,
    };

    const headerData = {
      "Content-Type": configJSON.signupEmailApiContentType,
      Token: this.state.userToken,
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.apiStripeSubscriptionCancelId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.signupAPiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.StripeCancelSubscription
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }

  handlGlobalApiError = (responseJson: any) => {
    if (responseJson && (responseJson.error || responseJson.errors)) {
      const errMsg = "Something went wrong!";
      this.setState({ formGlobalError: { [this.state.currentStep]: errMsg } });
      return true;
    }
  };

  apicallresponseData = (responseJson: any) => {
    this.handlGlobalApiError(responseJson);
    if (!(responseJson.error || responseJson.errors)) {
      console.log("responseJson", responseJson);
      this.handleSuccessResponse(responseJson);
    }
  };
  handleSuccessResponse(responseJson: any) {
    console.log("responseJsonresponseJsonresponseJsonresponseJson=====>>>>>>", responseJson);

    if(responseJson?.client_secret){
      this.setState({
        clientSecretKey: responseJson.client_secret ?? "",
      })
    }
    
    
    const emailAddressFromLocalStorage = sessionStorage.getItem("emailAddress");
    const { data, meta } = responseJson;

    console.log("emailAddressFromLocalStorage", emailAddressFromLocalStorage);
    console.log("data", data, meta);
    
    

    if (responseJson.data) {
      console.log("enter the If Here");
      
      this.setState({
        EmailPasswordID: data.id,
        passWordInformation: this.state.businessPassword,
        formGlobalError: { [this.state.currentStep]: "" },
      });
      sessionStorage.setItem("EmailPasswordID", data.id);

      if (meta?.token) {
        this.setState({
          userToken: meta.token,
        });
        sessionStorage.setItem("userToken", meta.token);
      }
    }

    const newStep = this.state.currentStep;
    console.log("newStep", newStep);
    

    this.setState({
      currentStep: newStep + 1,
      emailValidationResult: emailAddressFromLocalStorage,
    });

    if (newStep === 1) {
      console.log("enter the newStep Here StripeStripeStripeStripe");
      
      this.stripeProductDetailsAPI();
    }
  }

  subscriptionDetailsApiResponse = (responseJson: any) => {
    try {
      // handle global API error
    } catch (e) {
      console.error("❌ Error in handlGlobalApiError:", e);
    }

    const { currentStep } = this.state;
    if ([2, 5].includes(currentStep)) {
      const allPlans = responseJson?.data || [];
      const validPlanNames = allPlans.map((plan: any) => plan?.attributes?.name);
      const paymentPlanData = allPlans
        .filter((plan: any) => validPlanNames.includes(plan?.attributes?.name))
        .map((plan: any) => ({
          ...plan,
          attributes: {
            ...plan.attributes,
            platformManagement: false,
          },
        }));

      const platformManagementPaymentPlans = allPlans.filter(
        (plan: any) => plan?.attributes?.name === "Platform  Management"
      );
      this.setState({
        paymentPlanData,
        platformManagementPaymentPlans,
      });
    }
  };

  subscriptionCancelApiResponse = (responseJson: any) => {
    this.handlGlobalApiError(responseJson);
    if (!(responseJson.error || responseJson.errors)) {
      this.handleSubscriptionCancelResponse(responseJson);
    }
  };

  handleSubscriptionCancelResponse(responseJson: any) {
    const { data } = responseJson;

    if (data.attributes) {
      const prevStripePaymentData = this.state.stripePaymentData;
      const prevAttributes = prevStripePaymentData.attributes;

      const stripePaymentData = {
        ...prevStripePaymentData,
        attributes: {
          ...prevAttributes,
          status: data.attributes.status,
        },
      };

      this.setState({
        stripePaymentData,
      });
    }
  }

  async receive(from: string, message: Message) {
    const messageType = getName(MessageEnum.RestAPIResponceMessage);

    if (messageType === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (
        apiRequestCallId != null &&
        apiRequestCallId === this.apiUserRegistrationId
      ) {
        // this.apicallresponseData(responseJson);
        console.log("createIntentIdcreateIntentId here is respons09876543", responseJson);

      }
      if(apiRequestCallId === this.createIntentId){
        console.log("createIntentIdcreateIntentId here is respons", responseJson);
        this.apicallresponseData(responseJson);
      }
      if (
        apiRequestCallId != null &&
        apiRequestCallId === this.apiSubcriptionSelectionId
      ) {
        console.log("Subscription selection API response:", responseJson);
        const errorJson = message.getData(
          getName(MessageEnum.RestAPIResponceErrorMessage)
        );
        
        // Handle error cases
        if (errorJson || responseJson?.error || responseJson?.errors) {
          this.handlGlobalApiError(responseJson || { error: errorJson });
          console.error("❌ Subscription selection failed:", errorJson || responseJson?.error || responseJson?.errors);
          return;
        }
        
        // Handle success case - check for client_secret
        if (responseJson?.data || responseJson) {
          const subscriptionData = responseJson?.data || responseJson;
          const subscriptionId = subscriptionData?.id 
            || subscriptionData?.attributes?.id
            || subscriptionData?.data?.id;
          
          this.setState({
            stripePaymentData: subscriptionData,
            // Update selectedPlanData with subscription_id from the response
            selectedPlanData: {
              ...this.state.selectedPlanData,
              subscription_id: subscriptionId || this.state.selectedPlanData?.subscription_id || this.state.selectedPlanData?.productId
            }
          });
          
          // Check if client_secret is in the response (check multiple possible locations)
          const clientSecret = responseJson?.client_secret 
            || responseJson?.data?.client_secret 
            || responseJson?.data?.attributes?.client_secret
            || responseJson?.attributes?.client_secret;
          
          if (clientSecret) {
            console.log("✅ client_secret received, navigating to payment page");
            this.setState({
              clientSecretKey: clientSecret,
              currentStep: 6, // Navigate to Stripe payment page
            });
          } else {
            console.warn("⚠️ No client_secret in subscription selection response. Response:", responseJson);
          }
        }
      }
      if (
        apiRequestCallId != null &&
        apiRequestCallId === this.apiStripeProductDetailsId
      ) {
        this.subscriptionDetailsApiResponse(responseJson);
      }
      if (
        apiRequestCallId != null &&
        apiRequestCallId === this.apiStripeSubscriptionCancelId
      ) {
        this.subscriptionCancelApiResponse(responseJson);
      }
    }
  }
}
// Customizable Area End 
